const BASE = "/car-images";

const MODEL_IMAGES = {
  "DACIA|DUSTER": "dacia-duster",
  "DACIA|SANDERO": "dacia-sandero",
  "DACIA|SANDERO STEPWAY": "dacia-sandero",
  "RENAULT|CLIO": "renault-clio",
  "RENAULT|MEGANE": "renault-megane",
  "RENAULT|MEGANE SEDAN": "renault-megane",
  "FIAT|EGEA": "fiat-egea",
  "FIAT|EGEA CROSS": "fiat-egea",
  "FORD|FOCUS": "ford-focus",
  "FORD|TOURNEO COURIER": "ford-tourneo-courier",
  "TOYOTA|COROLLA": "toyota-corolla",
  "VOLKSWAGEN|GOLF": "vw-golf",
  "VOLKSWAGEN|PASSAT": "vw-passat",
  "OPEL|ASTRA": "opel-astra",
  "PEUGEOT|3008": "peugeot-3008",
  "HONDA|CIVIC": "honda-civic",
  "HYUNDAI|I20": "hyundai-i20",
};

const BRAND_IMAGES = {
  DACIA: "brand-dacia", FORD: "brand-ford", FIAT: "brand-fiat", RENAULT: "brand-renault",
  VOLKSWAGEN: "brand-volkswagen", TOYOTA: "brand-toyota", HYUNDAI: "brand-hyundai",
  OPEL: "brand-opel", PEUGEOT: "brand-peugeot", CITROEN: "brand-citroen", HONDA: "brand-honda",
  NISSAN: "brand-nissan", SKODA: "brand-skoda", SEAT: "brand-seat", KIA: "brand-kia",
  BMW: "brand-bmw", MERCEDES: "brand-mercedes", "MERCEDES-BENZ": "brand-mercedes",
  AUDI: "brand-audi", VOLVO: "brand-volvo", MITSUBISHI: "brand-mitsubishi",
  SUZUKI: "brand-suzuki", CHERY: "brand-chery", MG: "brand-mg",
};

const trU = (s) => (s || "").trim()
  .replace(/ç/g, "C").replace(/ğ/g, "G").replace(/ı/g, "I")
  .replace(/ö/g, "O").replace(/ş/g, "S").replace(/ü/g, "U").replace(/İ/g, "I")
  .toUpperCase();

export function autoVehicleImage(brand, model) {
  const b = trU(brand);
  const m = trU(model);
  const mk = `${b}|${m}`;
  if (MODEL_IMAGES[mk]) return `${BASE}/${MODEL_IMAGES[mk]}.jpg`;
  if (BRAND_IMAGES[b]) return `${BASE}/${BRAND_IMAGES[b]}.jpg`;
  return `${BASE}/generic.jpg`;
}

export function hasOwnPhoto(v) {
  return Boolean(v && (v.photo || (v.photos && v.photos.length > 0)));
}
